import * as React from 'react';
import { Link, NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { MutationFunc, Query } from 'react-apollo';

import Form from '../../../FormGenerator/Form';
import { IFormField } from '../../../../interfaces/interfaces';
import { Title, Button, Modal } from '../../../../modules/modules';
import { forgottenPwFields } from '../../../../formFields';
import CountryService from '../../../../services/CountryService';

interface IForgottenPwProps extends RouteComponentProps<{ language: string }> {
  type?: string;
  onClose?: (e: any) => void;
  forgottenPw?: MutationFunc;
}

interface IForgottenPwState {
  formFields: any[];
  formValues: any;
  modals: any;
}

class ForgottenPw extends React.Component<IForgottenPwProps> {
  public state: IForgottenPwState;
  constructor(props: IForgottenPwProps) {
    super(props);

    this.state = {
      formFields: forgottenPwFields,
      formValues: {},
      modals: {
        message: false
      }
    };
  }

  public handleChange = (value: any, field: string) => {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState = (fields: any) => {
    this.setState({ fields });
  }

  public async handleSend(form: any) {
    const validation = await form.validate((fields: any) => {
      this.setFormState(fields);
    });

    this.setState({ errorMessage: '' });

    if (validation) {
      this.forgottenPw();
    }
  }

  public toggleModal(modal: string, open?: boolean) {
    if (open === undefined) {
      open = !this.state.modals[modal];
    }

    this.setState({ modals: { ...this.state.modals, [modal]: open } });
  }

  public render() {
    const { countryCode, language } = CountryService.GetInstance();

    return (
      <React.Fragment>
        <div className={'forgottenPw'}>
          <div>
            <div className="form form--forgottenPw">
              <Form 
                fields={this.state.formFields} 
                values={this.state.formValues} 
                handleChange={this.handleChange}
              >
                {(form: any) => {
                  return (
                    <div>
                      <Button
                        onClick={() => {
                          this.handleSend(form);
                        }}
                      >
                        Send
                      </Button>
                    </div>
                  );
                }}
              </Form>
            </div>
          </div>
          <div className="forgottenPw__link">
            <Link to={`/${countryCode}/login`} className="link">
              Back to login
            </Link>
          </div>
        </div>

        <Modal type="message" open={this.state.modals.message} onClose={() => this.toggleModal('message', false)}>
          <div className="modal__title">If a user exists, a reset link was sent to him.</div>
          <Link to={`/${countryCode}/login`} className="link">
            Log in
          </Link>
        </Modal>
      </React.Fragment>
    );
  }

  private async forgottenPw() {
    if (this.props.forgottenPw == undefined) {
      return;
    }

    const { countryCode } = CountryService.GetInstance();

    const values = this.state.formValues;

    const variables = {
      email: values.Email,
      language: countryCode,
      countryCode,
    };

    this.props.forgottenPw({ variables });

    this.setState({ modals: { ...this.state.modals, ['message']: true } });
  }
}

export default withRouter(ForgottenPw);



// WEBPACK FOOTER //
// ./src/components/Query/User/ForgottenPw/ForgottenPw.tsx